export const WORDPRESS_LOGIN_URL = "https://academia8islas.com/acceso-aula/";

export const isProductionAula = (hostname = window.location.hostname) =>
  hostname === "aula.academia8islas.com";
